import { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';

/**
 * Composant wrapper pour Droppable qui le rend compatible avec le mode strict de React
 * En utilisant requestAnimationFrame pour retarder le rendu du Droppable
 * jusqu'après le double rendu du mode strict
 */
const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const schedule =
      typeof window !== 'undefined' && window.requestAnimationFrame
        ? window.requestAnimationFrame
        : (cb) => setTimeout(cb, 0);
    const cancel =
      typeof window !== 'undefined' && window.cancelAnimationFrame
        ? window.cancelAnimationFrame
        : clearTimeout;

    const animation = schedule(() => setEnabled(true));
    return () => {
      cancel(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};

export default StrictModeDroppable;
